"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name;


  if (!name || !theme.props || !theme.props[name]) {
    return {};
  }

  return theme.props[name];
}

exports.default = getThemeProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui/styles/getThemeProps.js
// module id = zc09
// module chunks = 11